module.exports = __webpack_public_path__ + "static/media/hero-awair-bg@lg.6b7ef0ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awair/hero-awair-bg@lg.jpg
// module id = 165
// module chunks = 0